import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody } from "reactstrap";

const ConfigSection = ({ icon, title, description, actions, children }) => (
  <Card className="config-section-card">
    <CardBody>
      <div className="config-section-header">
        <div className="config-section-heading">
          {icon && (
            <span className="config-section-icon">
              <i className={`bx ${icon}`} />
            </span>
          )}
          <div>
            <h5 className="config-section-title mb-0">{title}</h5>
            {description && <p className="config-section-description mb-0">{description}</p>}
          </div>
        </div>
        {actions && <div className="config-section-actions">{actions}</div>}
      </div>
      <div className="orange-separator margin-separator" />
      <div className="config-section-body">{children}</div>
    </CardBody>
  </Card>
);

ConfigSection.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
};

export default ConfigSection;
